// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__FzPXj","scrollbars":"styles_scrollbars__foaxs","slideInSearchBar":"styles_slideInSearchBar__RnevU"};